import { Chip } from "@material-ui/core";
import { memo } from "react";
import { useEspelhoFaturamentoService } from "../context/EspelhoFaturamentoContext";

const SituationChip = ({ situation }) => {
  const { handleRemoveChip } = useEspelhoFaturamentoService();

  return (
    <>
      <Chip
        key={situation.id}
        label={situation.desc}
        onDelete={() => {
          handleRemoveChip(situation);
        }}
        color={"primary"}
      />
    </>
  );
};

export default memo(SituationChip);
